import { useState } from "react";
import { usePWA } from "@/context/PWAContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Download, Share, Plus } from "lucide-react";

export function InstallDrelik({ variant = "outline", className = "" }) {
  const pwa = usePWA();
  const [iosOpen, setIosOpen] = useState(false);
  if (!pwa || pwa.installed || pwa.isStandalone) return null;
  if (!pwa.canInstall && !pwa.isIOS) return null;

  const onClick = async () => {
    if (pwa.canInstall) { await pwa.promptInstall(); }
    else if (pwa.isIOS) { setIosOpen(true); }
  };

  return (
    <>
      <Button variant={variant} onClick={onClick} className={`rounded-lg ${className}`} data-testid="install-drelik-btn">
        <Download className="h-4 w-4 mr-1.5" /> Install Drelik
      </Button>
      <Dialog open={iosOpen} onOpenChange={setIosOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Add Drelik to your Home Screen</DialogTitle>
            <DialogDescription>Install Drelik as an app on your iPhone or iPad.</DialogDescription>
          </DialogHeader>
          <ol className="space-y-3 text-sm mt-2">
            <li className="flex items-center gap-3"><span className="h-7 w-7 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold shrink-0">1</span> Tap the <Share className="h-4 w-4 inline" /> <strong>Share</strong> button in Safari's toolbar.</li>
            <li className="flex items-center gap-3"><span className="h-7 w-7 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold shrink-0">2</span> Scroll and tap <Plus className="h-4 w-4 inline" /> <strong>Add to Home Screen</strong>.</li>
            <li className="flex items-center gap-3"><span className="h-7 w-7 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold shrink-0">3</span> Tap <strong>Add</strong> — Drelik will appear on your home screen.</li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
}
